module.exports = __webpack_public_path__ + "static/media/undraw_fingerprint.597d5277.svg";